export default __webpack_public_path__ + "static/media/contact-person.4dda4618.svg";